import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MuiModule } from '@move/ui';
import { TranslateModule } from '@ngx-translate/core';
import { MmuFooterModule } from '../footer/mmu-footer.module';
import { resolveTranslated } from '../i18n/resolve-translated';
import { MmuError404ViewComponent } from './error-404/mmu-error-404-view.component';


const routes: Routes = [
  {
    path: '404',
    component: MmuError404ViewComponent,
    resolve: { title: resolveTranslated('error404Page.title') }
  },
  {
    path: '**',
    component: MmuError404ViewComponent,
    resolve: { title: resolveTranslated('error404Page.title') }
  }
];

/**
 * This module is designed as a lazy-loaded module. Do not import/export it in the MmuModule, as this will break the app routing
 * by overriding the app's home route!
 */
@NgModule({
  declarations: [MmuError404ViewComponent],
  imports: [RouterModule.forChild(routes), MuiModule, TranslateModule, MmuFooterModule],
  exports: [RouterModule]
})
export class MmuErrorModule {}
